/**
 * terrain.js — Terrain type definitions
 * Extracted to avoid circular imports between MapContext and mapCodec.
 */

export const TERRAIN_TYPES = [
  { id: 'empty',        label: 'Empty',         color: 'transparent', passable: true  },
  // ── Floors ────────────────────────────────────────────────────────────────
  { id: 'stone_floor',  label: 'Stone',         color: '#5a5a72',     passable: true  },
  { id: 'dirt',         label: 'Dirt',          color: '#7a5c2a',     passable: true  },
  { id: 'grass',        label: 'Grass',         color: '#2d6b1f',     passable: true  },
  { id: 'wood_floor',   label: 'Wood',          color: '#6b4226',     passable: true  },
  { id: 'sand',         label: 'Sand',          color: '#c2a050',     passable: true  },
  { id: 'snow',         label: 'Snow',          color: '#c8dde8',     passable: true  },
  { id: 'deep_snow',    label: 'Deep Snow',     color: '#a8c8e0',     passable: true, difficult: true },
  { id: 'ice',          label: 'Ice',           color: '#90b8d0',     passable: true  },
  { id: 'mud',          label: 'Mud',           color: '#5a4020',     passable: true, difficult: true },
  { id: 'marble_floor', label: 'Marble',        color: '#c8c0b8',     passable: true  },
  { id: 'cobblestone',  label: 'Cobblestone',   color: '#6a6a58',     passable: true  },
  { id: 'carpet',       label: 'Carpet',        color: '#7a2a4a',     passable: true  },
  { id: 'gravel',       label: 'Gravel',        color: '#7a7a6a',     passable: true  },
  { id: 'obsidian',     label: 'Obsidian',      color: '#1a1a28',     passable: true  },
  // ── Hazards ───────────────────────────────────────────────────────────────
  { id: 'water',        label: 'Deep Water',    color: '#1a4a8a',     passable: false },
  { id: 'shallow_water',label: 'Shal. Water',   color: '#3a7abf',     passable: true, difficult: true },
  { id: 'swim_water',   label: 'Swim Water',    color: '#2a5a9a',     passable: true, difficult: true, swim: true },
  { id: 'climb_rock',   label: 'Climb Rock',    color: '#6a5a4a',     passable: true, difficult: true, climb: true },
  { id: 'lava',         label: 'Lava',          color: '#cc3300',     passable: false },
  { id: 'swamp',        label: 'Swamp',         color: '#3a5a2a',     passable: true, difficult: true },
  { id: 'bramble',      label: 'Bramble',       color: '#3a4a1a',     passable: true, difficult: true },
  { id: 'void',         label: 'Void',          color: '#0a0a10',     passable: false },
  // ── Walls ─────────────────────────────────────────────────────────────────
  { id: 'wall',         label: 'Stone Wall',    color: '#1a1a2a',     passable: false },
  { id: 'cave_rock',    label: 'Cave Rock',     color: '#2a2a3a',     passable: false },
  { id: 'wood_wall',    label: 'Wood Wall',     color: '#5a3a18',     passable: false },
  { id: 'brick_wall',   label: 'Brick Wall',    color: '#7a3a2a',     passable: false },
  { id: 'hedge',        label: 'Hedge',         color: '#1a4a1a',     passable: false },
  { id: 'iron_bars',    label: 'Iron Bars',     color: '#4a4a5a',     passable: false },
];

export const TERRAIN_MAP = Object.fromEntries(TERRAIN_TYPES.map((t) => [t.id, t]));
